import { Component } from '@angular/core';

@Component({
  selector: 'app-annule-cmd-fourn',
  templateUrl: './annule-cmd-fourn.component.html',
  styleUrls: ['./annule-cmd-fourn.component.scss']
})
export class AnnuleCmdFournComponent {}
